import { DatePicker } from '@mui/lab';
import { TextField } from '@mui/material';
import { useController } from 'react-hook-form';
import { isDefaultDotnetDate } from 'shared/utility';

interface OverrideUntilFieldProps {
    name: string;
    rules?: Object;
    label: string;
    error?: boolean;
    helperText?: string;
}

export default function OverrideUntilField({ name, rules, label, error, helperText }: OverrideUntilFieldProps) {
    const {
        field: { value, onChange },
    } = useController({
        name,
        rules,
    });
    return (
        <DatePicker
            label={label}
            value={isDefaultDotnetDate(value) ? null : value}
            onChange={onChange}
            renderInput={params => <TextField {...params} error={error} helperText={helperText} />}
            inputFormat='MM-dd-yy'
            mask='__-__-__'
            showTodayButton
        />
    );
}
